import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/compass-color.vue
var c = {
	name: "DtIconCompassColor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["id"];
function f(e, t, n, c, f, p) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([p.iconSizeClass, "d-icon d-icon--compass-color"]),
		"data-qa": p.dataQA,
		"aria-hidden": p.ariaHidden,
		role: "img",
		"data-name": "Compass Color",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("path", {
		d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0Zm-5.076-5.188a1 1 0 0 1 1.265 1.264l-1.804 5.411a3.002 3.002 0 0 1-1.898 1.898l-5.41 1.804a1 1 0 0 1-1.265-1.265l1.803-5.411a3.001 3.001 0 0 1 1.898-1.898l5.41-1.803Zm-4.778 3.7a1.002 1.002 0 0 0-.633.633L9.34 14.659l3.514-1.17a1.004 1.004 0 0 0 .632-.633l1.171-3.514-3.512 1.172ZM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z",
		fill: `url(#${e.uniqueID}a)`
	}, null, 8, u), i("defs", null, [i("linearGradient", {
		id: `${e.uniqueID}a`,
		x1: "1",
		y1: "1",
		x2: "23",
		y2: "23",
		gradientUnits: "userSpaceOnUse"
	}, [...t[0] || (t[0] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, d)])], 10, l);
}
var p = /* @__PURE__ */ n(c, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=compass-color.js.map